export enum CharacterDonationByCharacterSortEnum {
  RANK = 'RANK',
  CHARACTER_NAME = 'CHARACTER_NAME',
  STORY = 'STORY',
  USERNAME = 'USERNAME',
  DONATION = 'DONATION',
}
